import { ErrorBoundary } from 'react-error-boundary';

import { useAuthorization } from '@/shared/hooks';

import { AdminConfigurationSection } from '@/widgets/admin';
import { CpuMetric, DiskMetric, GpuMemoryMetric, IOMetrics, MemoryMetric } from '@/widgets/monitoring';

import styles from './AdminPage.module.css';

export const AdminPage: React.FC = () => {
  const { hasAnyRole } = useAuthorization();

  const canAccessMonitoring = hasAnyRole(['admin', 'manager']);

  return (
    <div className={styles.adminPage}>
      <div className={styles.configurationSection}>{canAccessMonitoring && <AdminConfigurationSection />}</div>

      <div className={styles.monitoringSection}>
        {canAccessMonitoring && (
          <>
            <h2 className={styles.monitoringTitle}>Monitoring</h2>
            <div className={styles.chartSection}>
              <ErrorBoundary
                FallbackComponent={(props) => (
                  <CpuMetric.Error
                    {...props}
                    title="CPU 메트릭 오류"
                    description="CPU 메트릭 데이터를 불러오는 중 오류가 발생했습니다."
                  />
                )}>
                <CpuMetric.Content />
              </ErrorBoundary>

              <ErrorBoundary
                FallbackComponent={(props) => (
                  <GpuMemoryMetric.Error
                    {...props}
                    title="GPU 메트릭 오류"
                    description="GPU 사용량 데이터를 불러오는 중 오류가 발생했습니다."
                  />
                )}>
                <GpuMemoryMetric.Content />
              </ErrorBoundary>

              <ErrorBoundary
                FallbackComponent={(props) => (
                  <MemoryMetric.Error
                    {...props}
                    title="메모리 메트릭 오류"
                    description="메모리 메트릭 데이터를 불러오는 중 오류가 발생했습니다."
                  />
                )}>
                <MemoryMetric.Content />
              </ErrorBoundary>

              <ErrorBoundary
                FallbackComponent={(props) => (
                  <DiskMetric.Error
                    {...props}
                    title="디스크 메트릭 오류"
                    description="디스크 메트릭 데이터를 불러오는 중 오류가 발생했습니다."
                  />
                )}>
                <DiskMetric.Content />
              </ErrorBoundary>

              <ErrorBoundary
                FallbackComponent={(props) => (
                  <IOMetrics.Error
                    {...props}
                    title="I/O 메트릭 오류"
                    description="I/O 메트릭 데이터를 불러오는 중 오류가 발생했습니다."
                  />
                )}>
                <IOMetrics.Content />
              </ErrorBoundary>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
